import React from 'react';
export function Footer() {
  const links = ['Impressum', 'Datenschutzerklärung (DSGVO)', 'AGB', 'Widerrufsrecht', 'Kontakt'];
  return <footer className="bg-brand-text px-4 py-12 text-center text-sm text-white/65" data-id="element-61">
      <div className="mx-auto max-w-4xl" data-id="element-62">
        <div className="mb-8 flex items-center justify-center gap-2 font-serif text-xl font-bold text-white" data-id="element-63">
          <span aria-hidden="true" data-id="element-64">🧘‍♀️</span> YOGA BEREIT
        </div>
        <nav aria-label="Rechtliche Links" className="mb-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3" data-id="element-65">
          {links.map(link => <a key={link} href="#" className="transition-colors hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-66">
              {link}
            </a>)}
        </nav>
        <p data-id="element-67">© 2026 Yoga Bereit</p>
      </div>
    </footer>;
}